import React from "react";
import styles from "./LogbookItem.module.scss";

export const LogbookItemContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.logbookItemContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
